import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { history, getState } from "../../../store/configure/configureStore";
//
import "./PageNotFoundStyles.scss";

const PageNotFound = () => {
  const loggedInUserRole = getState().auth?.userRole; // Get role from Redux

  useEffect(() => {
    if (loggedInUserRole) {
      //redirect user when when login url entered
      window?.location?.pathname === "/login" && history?.push("/");
    }
  }, [loggedInUserRole, history]);

  return (
    <div className="page-not-found-wrapper">
      <div>
        <h1>404 - Page Not Found</h1>
        <p>Sorry, the page you are looking for does not exist.</p>
      </div>
      <div
        className="action-block"
        onClick={() => {
          !loggedInUserRole && history.push("/login");
        }}
      >
        {!loggedInUserRole && "Go to login page"}
      </div>
    </div>
  );
};

PageNotFound.propTypes = {
  label: PropTypes.string.isRequired,
  Icon: PropTypes.func.isRequired,
  btnData: PropTypes.array,
};

PageNotFound.defaultProps = {
  btnData: [],
};

export default PageNotFound;
